// ✅ src/data/partnersData.js

import zoho from "../assets/partners/zoho.png";
import ingram from "../assets/partners/ingram.png";
import redington from "../assets/partners/redington.png";
import salesforce from "../assets/partners/salesforce.png";
import aws from "../assets/partners/aws.png";
import google from "../assets/partners/google.png";
import azure from "../assets/partners/azure.png";
import tableau from "../assets/partners/tableau.png";
import contentstack from "../assets/partners/contentstack.png";
import optimizely from "../assets/partners/optimizely.png";
import sitecore from "../assets/partners/sitecore.png";
import bloomreach from "../assets/partners/bloomreach.png";
import algolia from "../assets/partners/algolia.png";
import commercetools from "../assets/partners/commercetools.png";

const partnersData = [
  {
    id: 1,
    name: "Zoho Corporation",
    description:
      "Zoho is a global technology company offering cloud software and business tools trusted by millions of users worldwide.",
    logo: zoho,
  },
  {
    id: 4,
    name: "Salesforce",
    description:
      "Salesforce is the world’s #1 CRM platform, helping organizations streamline customer engagement and sales automation.",
    logo: salesforce,
  },
  {
    id: 5,
    name: "Amazon Web Services (AWS)",
    description:
      "AWS provides reliable, scalable, and inexpensive cloud computing services trusted by enterprises worldwide.",
    logo: aws,
  },
  {
    id: 6,
    name: "Google Cloud",
    description:
      "Google Cloud accelerates digital transformation with cutting-edge AI, cloud infrastructure, and data solutions.",
    logo: google,
  },
  {
    id: 7,
    name: "Microsoft Azure",
    description:
      "Microsoft Azure delivers secure, scalable cloud computing services with unmatched enterprise integration.",
    logo: azure,
  },
  {
    id: 8,
    name: "Tableau",
    description:
      "Tableau helps people see and understand their data through powerful, easy-to-use analytics and visualization tools.",
    logo: tableau,
  },
  {
    id: 9,
    name: "Contentstack",
    description:
      "Contentstack is a leading composable digital experience platform enabling businesses to build and manage content at scale.",
    logo: contentstack,
  },
  {
    id: 10,
    name: "Optimizely",
    description:
      "Optimizely provides industry-leading digital experience and experimentation solutions to optimize business performance.",
    logo: optimizely,
  },
  {
    id: 11,
    name: "Sitecore",
    description:
      "Sitecore delivers a powerful digital experience platform that combines content management, personalization, and eCommerce.",
    logo: sitecore,
  },
  {
    id: 12,
    name: "Bloomreach",
    description:
      "Bloomreach offers an AI-powered digital experience platform for content, search, and commerce personalization.",
    logo: bloomreach,
  },
  {
    id: 13,
    name: "Algolia",
    description:
      "Algolia provides fast, reliable, and relevant search and discovery APIs for modern digital experiences.",
    logo: algolia,
  },
  {
    id: 14,
    name: "CommerceTools",
    description:
      "CommerceTools is a leading headless commerce platform enabling enterprises to build modern, API-first eCommerce solutions.",
    logo: commercetools,
  },
];

export default partnersData;
